module.exports = __webpack_public_path__ + "media/images/media-elements/video-overlay-a3e11f12b9aba47ac450eee2652e50dd.png";